import { FC, useEffect, useRef } from 'react'
import cx from 'classnames'
import { ContactFormProps } from 'src/form/ContactForm'

import { BlockTitleProps } from '../BlockTitle'

import * as SC from './styled'

export type ContactPushProps = {
  className?: string
  id?: string
  blockTitle: BlockTitleProps
  form: ContactFormProps
  success?: boolean
  resetHandler?: () => void
  texts?: {
    reset?: string
  }
}

const ContactPush: FC<ContactPushProps> = ({
  className,
  id = 'Contact',
  blockTitle,
  form,
  success,
  resetHandler,
  texts,
}) => {
  const containerRef = useRef<HTMLElement>(null)

  useEffect(() => {
    if (success) {
      containerRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }, [success])

  return (
    <SC.Container
      ref={containerRef}
      className={cx('ContactPush', className)}
      id={id}
    >
      <SC.BlockTitleStyled {...blockTitle} instant={success} />
      <SC.Wrapper>
        {!success ? (
          <SC.Form {...form} />
        ) : (
          <SC.Reset type="button" onClick={resetHandler} label={texts?.reset} />
        )}
      </SC.Wrapper>
    </SC.Container>
  )
}

export default ContactPush
